const environment = {
    apiBaseURL: process.env.VUE_APP_API_BASE_URL,
    websiteApiBaseUrl: process.env.VUE_APP_API_BASE_URL + 'website/',
    ecommerceApiBaseUrl: process.env.VUE_APP_API_BASE_URL + 'ecommerce/'
}

export {environment}
